import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
// import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableModule } from "@angular/material/table";
import { UserSearchDialogComponent } from "./usersearch-dialog.component";
import { UserSearchDialogService } from "./usersearch-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        // MatPaginatorModule,
        MatTableModule,
    ],

    declarations: [UserSearchDialogComponent],
    exports: [UserSearchDialogComponent],
    providers: [UserSearchDialogService],
})
export class UserSearchDialogModule {}